module.exports = __webpack_public_path__ + "static/media/window-alt.26981812.svg";